import { FETCHING_SHOWCASE, FETCHING_SHOWCASE_SUCCEEDED, FETCHING_SHOWCASE_FAILED, UPDATE_VIEWS_REQUEST, UPDATE_VIEWS_SUCCEEDED, UPDATE_VIEWS_FAILED, UPDATE_LIKES_REQUEST, UPDATE_LIKES_SUCCEEDED, UPDATE_LIKES_FAILED} from "constants/actionTypes.jsx";
import _ from "lodash";

const initialState = {
  loading: false,
  items: [],
  pagination: {
    currentPage: -1,
    totalPages: 1,
    recordsPerPage: 20,
    totalRecordsCount: 0
  },
  categories:[],
  industries:[],
  date:''
};

function showcaseReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_SHOWCASE: {
      const { page } = action.payload;

      var items = state.items;

      if (page === 0) {
        return {
          ...state,
          loading: true,
          items: [],
          pagination: {
            currentPage: -1,
            totalPages: 1,
            recordsPerPage: 20,
            totalRecordsCount: 0
          }
        }
      }

      return {
        ...state,
        loading: true
      }
    }
    
    case FETCHING_SHOWCASE_SUCCEEDED: {
      var items = state.items;
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = action.payload;

      if (currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records
      }

      const categories = records.map((data)=>{ return data.category });
      const industries = records.map((data)=>{return data.industry });

      return {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          currentPage,
          totalPages,
          recordsPerPage,
          totalRecordsCount
        },
        categories: categories,
        industries: industries
      }
    }

    case FETCHING_SHOWCASE_FAILED: {
      return {
        ...state,
        loading: false,
        items: null,
        error: action.payload
      }
    }

    case UPDATE_VIEWS_REQUEST: {
      const { id } = action.payload;
      return {
        ...state,
        id: id
      }
    }

    case UPDATE_VIEWS_SUCCEEDED: {

      const response = action.payload;

      var items = (state.items || [] ).map((item)=> {
        if(item.id === response.id){
          return response;
        }
        return item;
      });
      
      return {
        ...state,
        items: items
      }
    }

    case UPDATE_VIEWS_FAILED: {
      return {
        ...state,
         error: action.payload
      }
    }

    case UPDATE_LIKES_REQUEST: {
      const { id } = action.payload;
      return {
        ...state,
        id: id
      }
    }

    case UPDATE_LIKES_SUCCEEDED: {
      
      const response = action.payload;

      var items = (state.items || [] ).map((item)=> {
        if(item.id === response.id){
          return response;
        }
        return item;
      });
      
      return {
        ...state,
        items: items
      }
    }

    case UPDATE_LIKES_FAILED: {
      return {
        ...state,
         error: action.payload
      }
    }
    
    default:
        return state
  }
}

export { showcaseReducer };
